/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 10:05:45
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-07-15 14:37:24
 * @name: 用户模块服务
 * @Description: 用户模块服务
 * @FilePath: \project\src\module\user\user.service.js
 * @Author: desktop
 */
import userController from "./user.controller";
import userStorage from "@/storage/user.storage.js";
import { confirmation } from "@/utils/decorator";
const userService = class {
	constructor() {
		this.userController = new userController();
		this.userStorage = new userStorage(); // 用户存储
	}
	/**
	 * @Auther: 罗耀祖
	 * @LastEditors: 罗耀祖
	 * @description: 登录
	 * @param {Object} req 传参 
	 */
	login(req) {
		req.client = 'pc';
		return new Promise((resolve, reject) => {
			this.userController.login(req).then((ctx) => {
				this.setToken(ctx.response.data.auth_key);
				resolve(ctx.response);
			}).catch((ctx) => {
				reject(ctx.response);
			});
		})
	}
	/**
	 * @Auther: 罗耀祖
	 * @LastEditors: 罗耀祖
	 * @description: 退出登录
	 * @param {Object} req 传参 
	 */
	@confirmation('确认退出登录?')
	logout(req) {
		return new Promise((resolve, reject) => {
			this.userController.logout(req).then((ctx) => {
				this.removeToken();
				location.reload();
				resolve(ctx.response);
			}).catch((ctx) => {
				reject(ctx.response);
			});
		})
	}
	/**
	 * @Auther: 罗耀祖
	 * @LastEditors: 罗耀祖
	 * @description: 修改密码
	 * @param {Object} req 传参 
	 */
	updatePassword(req) {
		return new Promise((resolve, reject) => {
			this.userController.forgetPwd(req).then((ctx) => {
				resolve(ctx.response);
			}).catch((ctx) => {
				reject(ctx.response);
			});
		})
	}
	/**
	 * @Auther: 罗耀祖
	 * @LastEditors: 罗耀祖
	 * @description: 注册
	 * @param {Object} req 请求参数
	 */
	register(req) {
		return new Promise((resolve, reject) => {
			this.userController.register(req).then((ctx) => {
				resolve(ctx.response);
			}).catch((ctx) => {
				reject(ctx.response);
			});
		})
	}
	/**
	 * @Auther: 罗耀祖
	 * @LastEditors: 罗耀祖
	 * @description: 获取用户token
	 */
	getToken() {
		return this.userStorage.token;
	}
	/**
	 * @Auther: 罗耀祖
	 * @LastEditors: 罗耀祖
	 * @description: 设置用户token
	 */
	setToken(token) {
		this.userStorage.setToken(token);
	}
	/**
	 * @Auther: 罗耀祖
	 * @LastEditors: 罗耀祖
	 * @description: 移除用户token
	 */
	removeToken() {
		this.userStorage.removeToken();
	}
}
export default userService;